import { ComponentProps } from 'react';
import { ControlledMultiUserFieldEditorPopover } from './controlled-multi-user-field-editor-popover';
import { withFocusableSelect } from '../components/with-focusable-select';

export const MultiUserFieldEditorPopover = withFocusableSelect<
  number[],
  ComponentProps<typeof ControlledMultiUserFieldEditorPopover>
>(ControlledMultiUserFieldEditorPopover);
